import { Breadcrumbs, HorizontalLinkGroup } from "components/navigation";
import { UserAccess } from "components/user-access";
import { EmployeeAssessmentsOverview } from "pages/employee-assessments/overview/EmployeeAssessmentsOverview";
import { EmployeeAssessmentsRisk } from "pages/employee-assessments/risk/EmployeeAssessmentsRisk";
import { EmployeeAssessmentsUpcoming } from "pages/employee-assessments/upcoming/EmployeeAssessmentsUpcoming";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

export function EmployeeAssessments({ breadcrumbs }) {
    const requiredAction = "EmployeeAssessments:View";

    const routes = [
        { location: "/driver-assessments/overview", title: "Overview" },
        { location: "/driver-assessments/risk", title: "Risk" },
        { location: "/driver-assessments/upcoming", title: "Upcoming" }
    ];

    return <UserAccess
        perform={requiredAction}
        yes={() => (
            <>
                <div className="row">
                    <Breadcrumbs items={breadcrumbs} />
                    <h1>Driver Assessments Hub</h1>

                    <div className="spacer-bottom">
                        <HorizontalLinkGroup
                            links={routes}
                            exactRouteMatch={false}
                        ></HorizontalLinkGroup>
                    </div>

                    <Routes>
                        <Route path="overview" element={<EmployeeAssessmentsOverview />} />
                        <Route path="risk" element={<EmployeeAssessmentsRisk />} />
                        <Route path="upcoming" element={<EmployeeAssessmentsUpcoming />} />
                        <Route path="" element={<Navigate to="/driver-assessments/overview" replace />} />
                    </Routes>
                </div>
            </>
        )}
    />
}
